import React from 'react';
import EntityField from '../../../contentful/EntityField';
import {NavLink as Link} from 'react-router-dom';
import Loading from './../misc/Loading';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import {calculatePrice} from '../../../../model/transformers/variant';
import update from 'immutability-helper';

class VariantComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handleAssetChange = this.handleAssetChange.bind(this);
    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
  }

  handleAssetChange(name, entity) {
    const event = {
      target: {
        name: name,
        value: entity
      }
    };

    this.handleFieldChange(event);
  }

  handleFieldChange(e) {
    const newData = {
      variant: {}
    };

    newData.variant[e.target.name] = {
      $set: e.target.value
    };

    const props = update(this.props, newData);

    this.props.onChange(props);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handlePublish(e) {
    e.preventDefault();
    this.props.onPublish();
  }

  handleUnpublish(e) {
    e.preventDefault();
    this.props.onUnpublish();
  }

  handleSave(e) {
    e.preventDefault();
    this.props.onSave();
  }

  render() {
    if (this.props.variant) {
      const variant = this.props.variant;
      const priceFormated = Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(variant.rawPrice || variant.price);

      return (
        <section className="mf-variant mf-model">
          <ol className="breadcrumb mf-margin-top-20">
            <li><Link to="/">Forsiden</Link></li> {/* Frontpage */}
            <li><Link to="/nybilinformasjon/">Nybilinformasjon</Link></li> {/* Makes list */}
            <li>
              <Link to={`/modeller/${this.props.model.make.id}`}>{this.props.model.make.name}</Link> {/* Models list */}
            </li>
            <li>
              <Link to={`/modeller/${this.props.model.make.id}/modell/${this.props.model.id}`}>{this.props.model.name}</Link> {/* Model */}
            </li>
            <li className="active">{variant.name}</li> {/* Variant */}
          </ol>

          <form onSubmit={this.handleSubmit}>
            <div className="page-header">
              <div className="pull-right">
                {this.props.working &&
                  <span>&nbsp;<i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...</span>
                }
                {!variant.archived &&
                  <button type="submit" className="btn btn-default" disabled={!this.props.modified || this.props.working}>
                    <span>Lagre endringer</span>
                  </button>
                }
                &nbsp;
                <button type="button" className="btn btn-success" disabled={this.props.variant.archived || (this.props.variant.published && !this.props.variant.updated) || this.props.working || this.props.modified} onClick={this.handlePublish}>
                  <span>Publiser</span>
                </button>
                &nbsp;
                <button type="button" className="btn btn-warning" disabled={this.props.variant.draft || this.props.working || this.props.modified} onClick={this.handleUnpublish}>
                  <span>Avpubliser</span>
                </button>
                &nbsp;
                {!variant.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={this.props.working}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onArchive();
                    }}
                  >
                    <span>Arkiver</span>
                  </button>
                }
                {variant.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={this.props.working}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onUnArchive();
                    }}
                  >
                    <span>Gjenopprett</span>
                  </button>
                }
              </div>

              <h1>
                {variant.name} <PublishStatusDot entry={variant} /><br />
                <small>{this.props.model.make.name} &ndash; <em>{this.props.model.name}</em></small>
              </h1>
            </div>

            {/* Display any error message: */}
            {this.props.error &&
              <div className="alert alert-danger">
                {this.props.error}
              </div>
            }

            <div className="row">
              <div className="col-xs-12 col-md-6">
                {!variant.custom && <div className="form-group">
                  <label>Visningsnavn</label>
                  <input type="text" className="form-control" disabled={this.props.working || variant.archived} name="displayname" defaultValue={variant.displayname} onChange={this.handleFieldChange} />
                </div>}
                {variant.custom && <div className="form-group">
                  <label>Navn</label>
                  <input type="text" className="form-control" disabled={this.props.working || variant.archived} name="name" defaultValue={variant.name} onChange={this.handleFieldChange} />
                </div>}

                {!variant.custom && <div className="form-group">
                  <label>Motorvolum (manuelt)</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="engineVolumeManual" disabled={this.props.working || variant.archived} defaultValue={variant.engineVolumeManual} onChange={this.handleFieldChange} />
                    <div className="input-group-addon">cm<sup>3</sup></div>
                  </div>
                </div>}

                <div className="form-group">
                  <label>Variantbeskrivelse</label>
                  <input type="text" className="form-control" name="variantDescription" disabled={this.props.working || variant.archived} defaultValue={variant.variantDescription} onChange={this.handleFieldChange} />
                </div>

                <div className="form-group">
                  <label>Reg.avgift (Påkrevet for varebil)</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      disabled={this.props.working || variant.archived || (this.props.model.category && !this.props.model.category.includes('Varebil'))}
                      required={this.props.model.category.includes('Varebil')}
                      name="regFee"
                      placeholder="Standard"
                      defaultValue={variant.regFee}
                      onChange={this.handleFieldChange}
                    />
                    <div className="input-group-addon">,-</div>
                  </div>
                  <span className="help-block">
                    {variant.regFee && <span>Utregnet pris uten mva.{this.props.model.make.name === 'Mitsubishi' && ' (før fraktpåslag)'}: {Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(calculatePrice(parseInt(variant.regFee, 10), parseInt(variant.rawPrice || variant.price, 10)))},-</span>}
                  </span>
                </div>

                {this.props.model.category.includes('Elbil') && (
                  <>
                    <div className="form-group">
                      <label>WLTP</label>
                      <input type="number" className="form-control" name="wltp" disabled={this.props.working || variant.archived} defaultValue={variant.wltp} onChange={this.handleFieldChange} />
                    </div>
                    <div className="form-group">
                      <label>Batteristørrelse (Brutto)</label>
                      <input type="number" step="0.1" className="form-control" name="batterySizeGross" disabled={this.props.working || variant.archived} defaultValue={variant.batterySizeGross} onChange={this.handleFieldChange} />
                    </div>
                    <div className="form-group">
                      <label>Batteristørrelse (Netto)</label>
                      <input type="number" step="0.1" className="form-control" name="batterySizeNet" disabled={this.props.working || variant.archived} defaultValue={variant.batterySizeNet} onChange={this.handleFieldChange} />
                    </div>
                  </>
                )}
              </div>

              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Variantgruppe</label>
                  <EntityField
                    name="variantGroup"
                    value={variant.variantGroup}
                    onChange={this.handleAssetChange}
                    disabled={this.props.working || variant.archived}
                    searcher={this.props.variantGroupSearcher}
                    searchOnOpen={true}
                  />
                </div>
                {this.props.model.make.slug === 'hongqi' && <>
                  <div className="form-group">
                    <label>Deaktivert tekst</label>
                    <input type="text" className="form-control" disabled={this.props.working || variant.archived} name="deactivatedText" defaultValue={variant.deactivatedText} onChange={this.handleFieldChange} />
                    <span className="help-block">
                      Eks. &quot;Midlertidig utsolgt&quot;<br />Om tekst er satt vil dette vises istedenfor pris. Varianten vil være synlig, men deaktivert i konfiguratoren.
                    </span>
                  </div>
                </>}
              </div>

              <div className="col-xs-12">
                {!variant.custom && <h2>Data fra Axapta</h2>}
                <hr />
              </div>

              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Utstyrsnivå</label>
                  <EntityField
                    name="equipmentLevel"
                    contentType="equipmentLevel"
                    value={variant.equipmentLevel}
                    onChange={this.handleAssetChange}
                    searchParams={{
                      'fields.model.sys.id': this.props.model.id
                    }}
                    searchOnOpen={true}
                    disabled={!variant.custom || (this.props.working || variant.archived)}
                  />
                </div>
              </div>

              {!variant.custom && <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Navn</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="name" defaultValue={variant.name} disabled={!variant.custom || (this.props.working || variant.archived)} onChange={this.handleFieldChange} />
                    <div className="input-group-addon">{variant.custom ? '' : 'Data fra Axapta'}</div>
                  </div>
                </div>
              </div>}
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Modellkode</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="modelCode" defaultValue={variant.modelCode} disabled={!variant.custom || (this.props.working || variant.archived)} onChange={this.handleFieldChange}/>
                    <div className="input-group-addon">{variant.custom ? '' : 'Data fra Axapta'}</div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>År</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="year" defaultValue={variant.year} disabled={!variant.custom || (this.props.working || variant.archived)} onChange={this.handleFieldChange}/>
                    <div className="input-group-addon">{variant.custom ? '' : 'Data fra Axapta'}</div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Pris</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="price" defaultValue={variant.custom ? variant.price : priceFormated} disabled={!variant.custom || (this.props.working || variant.archived)} onChange={this.handleFieldChange}/>
                    <div className="input-group-addon">{variant.custom ? '' : 'Data fra Axapta'}</div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Utstyrsnivåkode</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="optionCode" defaultValue={variant.optionCode} disabled={!variant.custom || (this.props.working || variant.archived)} onChange={this.handleFieldChange}/>
                    <div className="input-group-addon">{variant.custom ? '' : 'Data fra Axapta'}</div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Beskrivelse utstyrsnivå</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="optionDescription" defaultValue={variant.optionDescription} disabled={!variant.custom || (this.props.working || variant.archived)} onChange={this.handleFieldChange}/>
                    <div className="input-group-addon">{variant.custom ? '' : 'Data fra Axapta'}</div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Chassistype (kode)</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="vehicleClass" defaultValue={variant.vehicleClass} disabled={!variant.custom || (this.props.working || variant.archived)} onChange={this.handleFieldChange}/>
                    <div className="input-group-addon">{variant.custom ? '' : 'Data fra Axapta'}</div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Vareromstørrelse (kode)</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="cargoLengthHeightCode" defaultValue={variant.cargoLengthHeightCode} disabled={!variant.custom || (this.props.working || variant.archived)} onChange={this.handleFieldChange}/>
                    <div className="input-group-addon">{variant.custom ? '' : 'Data fra Axapta'}</div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Kjøretøystype</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="vehicleGroup" defaultValue={variant.vehicleGroup} disabled={!variant.custom || (this.props.working || variant.archived)} onChange={this.handleFieldChange}/>
                    <div className="input-group-addon">{variant.custom ? '' : 'Data fra Axapta'}</div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Seter</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="numberOfSeats" defaultValue={variant.numberOfSeats} disabled={!variant.custom || (this.props.working || variant.archived)} onChange={this.handleFieldChange}/>
                    <div className="input-group-addon">{variant.custom ? '' : 'Data fra Axapta'}</div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Hjuldrift</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="poweredAxles" defaultValue={variant.poweredAxles} disabled={!variant.custom || (this.props.working || variant.archived)} onChange={this.handleFieldChange}/>
                    <div className="input-group-addon">{variant.custom ? '' : 'Data fra Axapta'}</div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Girkasse</label>
                  <div className="input-group">
                    <select defaultValue={variant.gearbox} className="form-control" name="gearbox" disabled={!variant.custom || (this.props.working || variant.archived)} onChange={this.handleFieldChange}>
                      <option value="Unknown">Ikke satt</option>
                      <option value="Manual">Manuell</option>
                      <option value="Automatic">Automatisk</option>
                    </select>
                    <div className="input-group-addon">{variant.custom ? '' : 'Data fra Axapta'}</div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Motorvolum</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="engineVolume" defaultValue={variant.engineVolume} disabled={!variant.custom || (this.props.working || variant.archived)} onChange={this.handleFieldChange}/>
                    <div className="input-group-addon">{variant.custom ? '' : 'Data fra Axapta'}</div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Hestekrefter</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="engineHorsepower" defaultValue={variant.engineHorsepower} disabled={!variant.custom || (this.props.working || variant.archived)} onChange={this.handleFieldChange}/>
                    <div className="input-group-addon">{variant.custom ? '' : 'Data fra Axapta'}</div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Drivstoff</label>
                  <div className="input-group">
                    <select defaultValue={variant.fuelType} className="form-control" name="fuelType" disabled={!variant.custom || (this.props.working || variant.archived)} onChange={this.handleFieldChange}>
                      <option value="Unknown">Ikke satt</option>
                      <option value="Petrol">Bensin</option>
                      <option value="Diesel">Diesel</option>
                      <option value="Electric">Elektrisk</option>
                      <option value="Hybrid">Hybrid</option>
                      <option value="Plug-in hybrid">Plug-in hybrid</option>
                    </select>
                    <div className="input-group-addon">{variant.custom ? '' : 'Data fra Axapta'}</div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                <div className="form-group">
                  <label>Forbruk</label>
                  <div className="input-group">
                    <input type="text" className="form-control" name="fuelConsumption" defaultValue={variant.fuelConsumption} disabled={!variant.custom || (this.props.working || variant.archived)} onChange={this.handleFieldChange}/>
                    <div className="input-group-addon">{variant.custom ? '' : 'Data fra Axapta'}</div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      );
    }
    return (
      <Loading title="Variant" text="Laster variant" />
    );
  }
}

export default VariantComponent;
